//WE.Flow.Html.Models.SingleModuleModel

export class SingleModuleModel {
    id: string = "";
}
